// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eee16fa9","977":"f6ea9f31"}[chunkId] + ".chunk.js";
};